/* SETWORK EDITORIAL — compact, useful interactions only. */
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-quantity]').forEach(function (control) {
    var input = control.querySelector('input');
    control.querySelectorAll('button').forEach(function (button) {
      button.addEventListener('click', function () {
        var value = parseInt(input.value || 1, 10);
        input.value = button.dataset.action === 'plus' ? value + 1 : Math.max(1, value - 1);
      });
    });
  });
});
